"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 */
var AbstractToken = /** @class */ (function () {
    function AbstractToken(encodedToken, rawToken) {
        var _this = this;
        this.getType = function () {
            return _this._encodedToken.claims.acr;
        };
        this.getId = function () {
            return _this._encodedToken.claims.jti;
        };
        this.getIssuer = function () {
            return _this._encodedToken.claims.iss;
        };
        this.getAudience = function () {
            return _this._encodedToken.claims.aud;
        };
        this.getSubject = function () {
            return _this._encodedToken.claims.sub;
        };
        this.expiredAt = function () {
            if (typeof _this._encodedToken.claims.exp === 'undefined') {
                return 0;
            }
            return _this._encodedToken.claims.exp;
        };
        this.isExpired = function () {
            var leeway = 60;
            var now = new Date();
            var expDate = new Date(0);
            expDate.setUTCSeconds(_this.expiredAt() + leeway);
            return now < expDate;
        };
        this._encodedToken = encodedToken;
        this._decodedToken = rawToken;
    }
    AbstractToken.prototype.getEncryptedToken = function () {
        return this._decodedToken;
    };
    return AbstractToken;
}());
exports.AbstractToken = AbstractToken;
